import { render, staticRenderFns } from "./AutobahnAppNotice.vue?vue&type=template&id=753477c1&scoped=true&"
import script from "./AutobahnAppNotice.vue?vue&type=script&lang=js&"
export * from "./AutobahnAppNotice.vue?vue&type=script&lang=js&"
import style0 from "./AutobahnAppNotice.vue?vue&type=style&index=0&id=753477c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753477c1",
  null
  
)

export default component.exports